import { useTranslation } from 'react-i18next'
import { Dispatch, SetStateAction } from 'react'
import MobileButton from '@/features/mobile-app/components/MobileButton/MobileButton'
import styles from './VenuesPage.module.scss'

interface VenuesPageProps {
  setIsMenuCardOpen: Dispatch<SetStateAction<boolean>>
}

function VenuesPage({ setIsMenuCardOpen }: VenuesPageProps) {
  const { t } = useTranslation()

  return (
    <div className={styles.venuesPageWrapper}>
      <div className={styles.headerContainer}>
        <p className={`body-bold-medium ${styles.headerTableDescription}`}>
          {t('MOBILE_APP.VENUEPAGE.HEADER.TABLE_DESCRIPTION')} 12
        </p>
        <p className={`body-medium ${styles.headerTitle}`}>
          {t('MOBILE_APP.VENUEPAGE.HEADER.TITLE')}
        </p>
        <MobileButton
          onClick={() => setIsMenuCardOpen(true)}
          variant="outlined"
          label={t('MOBILE_APP.VENUEPAGE.HEADER.MENU_BUTTON_LABEL')}
        />
      </div>
    </div>
  )
}

export default VenuesPage
